/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import Modal, { ModalBody, ModalTransition } from '@atlaskit/modal-dialog';
import { CREATE_FORM_MAX_WIDTH_IN_PX } from '../../constants';
import { ErrorBoundaryUI } from '../error-boundary-ui';

/**
 * ErrorBoundaryModal props are the same as those passed to LinkCreate, which
 * are used to control its active state
 */

export var ErrorBoundaryModal = function ErrorBoundaryModal(_ref) {
  var active = _ref.active,
    onClose = _ref.onClose;
  return jsx(ModalTransition, null, active && jsx(Modal, {
    testId: "link-create-error-boundary-modal",
    onClose: onClose,
    shouldScrollInViewport: true,
    width: "".concat(CREATE_FORM_MAX_WIDTH_IN_PX, "px")
  }, jsx(ModalBody, null, jsx(ErrorBoundaryUI, null))));
};